import * as React from 'react';
import c from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './Item.css';
import { formatNumber, formatDateItemFooter } from '../../lib/helpers';

export const ItemSummaryFooter = ({ item, isItemDetail, isStoreItem }) => {
  const viewsToday = formatNumber(item.stats.views_today);
  const viewsTodaySentence = ` (${viewsToday} view${viewsToday !== '1' ? 's' : ''} vandaag) `;
  return (
    <div className={styles.footer}>
      {isStoreItem &&
        <span>
          dumpertwinkel.nl
        </span>
      }
      {!isStoreItem && (
        <div className={c({ [styles.dateviews]: !isItemDetail })}>
          { formatDateItemFooter(item.date) } 
          <FontAwesomeIcon icon={['far', 'eye']} size="1x"/>
          {formatNumber(item.stats.views_total)}{isItemDetail && viewsTodaySentence}
        </div>
      )}
      {item.nsfw && (
        <div className={c( styles.nswf_icon, { [styles.rotated]: !isItemDetail })}>
          NSFW
        </div>
      )}
    </div>
  );
};
